/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2NotebookIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2NotebookIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2NotebookIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 14,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  stroke = "#323F4B"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2NotebookIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 14 14"
 style={{'--as-1-2hk8JS': alignSelf,'--mt-2-2hk8JS': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-2hk8JS': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-2hk8JS': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-2hk8JS': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-2hk8JS': opacity,'--w-10-2hk8JS': typeof width === 'number' ? `${width}px` : width,'--h-11-2hk8JS': typeof height === 'number' ? `${height}px` : height,'--f-12-2hk8JS': fill,'--a-7-2hk8JS': isAnimated ? animation : "none",'--sd-8-2hk8JS': isAnimated ? strokeDashoffset : 0,'--sd-9-2hk8JS': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<g
  data-testid="Tysiav2NotebookIcon.SvgGroup"
  data-view-path={viewPath}
 clipPath="url(#clip0_20062_2559)"
 className="views-block"
>
<path
  data-testid="Tysiav2NotebookIcon.SvgPath"
  data-view-path={viewPath}
 d="M8 13.5H1.5a1 1 0 01-1-1v-11a1 1 0 011-1H9M10.5 3.5l1.5-3 1.5 3V12a1.5 1.5 0 11-3 0V3.5zM3.5.5v13M6 4h2"
 strokeLinecap="round"
 strokeLinejoin="round"
 style={{'--s-13-2hk8JS': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
</g>
</svg>
{children}
</React.Fragment>)
}